import {
  AdditionalProfileDisclosureChange,
  Data,
  getInsuredProfile,
  getPolicyVersion,
  Policy,
  PolicyAdjustmentRequest,
  PolicyChangeType,
  Profile,
} from '../../../../domain'
import {
  AdjustmentInputConfig,
  ChangeType,
  ProfileChangeConfig,
} from '../../../../state/configuration'
import { hasUpdates, toUpdates } from '../../helpers'

const toAdditionalProfileDisclosureReducer =
  (existingData: Data, data: Data, { profileCode }: Profile) =>
  (
    policyAdjustment: PolicyAdjustmentRequest,
    input: AdjustmentInputConfig<ProfileChangeConfig>,
  ): PolicyAdjustmentRequest => {
    const updates = toUpdates(existingData, data)

    const changes: AdditionalProfileDisclosureChange[] = updates(input).map((update) => ({
      changeType: PolicyChangeType.ADDITIONAL_PROFILE_DISCLOSURE_CHANGE,
      profileCode,
      update,
    }))

    return {
      ...policyAdjustment,
      changes: [...policyAdjustment.changes, ...changes],
    }
  }

export const toAdditionalProfilePolicyAdjustment =
  (inputs: AdjustmentInputConfig[], policy: Policy, profile: Profile) =>
  (existingData: Data, data: Data, effectiveAt?: string): PolicyAdjustmentRequest => {
    const { quote } = getPolicyVersion(policy)

    const policyProfileReducer = toAdditionalProfileDisclosureReducer(
      existingData,
      data,
      profile,
    )

    return inputs.filter(hasUpdates(existingData, data)).reduce(
      (proposalAdjustment: PolicyAdjustmentRequest, input) => {
        switch (input.adjustment.changeType) {
          case ChangeType.PROFILE_DISCLOSURE:
            return policyProfileReducer(
              proposalAdjustment,
              input as AdjustmentInputConfig<ProfileChangeConfig>,
            )
          default:
            throw new Error(
              `AdjustmentChangeType ${input.adjustment.changeType} not supported by this`,
            )
        }
      },
      {
        policyId: policy.policyId,
        adjustmentType: 'MTA',
        changes: !getInsuredProfile(quote, profile.profileCode)
          ? [
              {
                changeType: PolicyChangeType.ADDITIONAL_PROFILE_CREATE_CHANGE,
                profileCode: profile.profileCode,
              },
            ]
          : [],
        ...(effectiveAt && { effectiveAt }),
      },
    )
  }
